"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getMinimumBondBalance = exports.isElectionClosed = exports.isControllerAddress = exports.isNewAccount = exports.getRegistry = exports.getPaymentInfo = exports.getTransactionParams = void 0;
var cache_1 = require("../../cache");
var api_1 = require("./api");
/**
 * Create a hash for a transaction that is params-specific and stay unchanged if no influcing fees
 *
 * @param {*} a
 * @param {*} t
 *
 * @returns {string} hash
 */
var hashTransactionParams = function (a, t, signedTx) {
    var _a, _b, _c, _d;
    // Nonce is added to discard previous estimation when account is synced.
    var prefix = "".concat(a.id, "_").concat(((_a = a.polkadotResources) === null || _a === void 0 ? void 0 : _a.nonce) || 0, "_").concat(t.mode);
    // Fees depends on extrinsic bytesize
    var byteSize = signedTx.length;
    // And on extrinsic weight (which varies with the method called)
    switch (t.mode) {
        case "send":
            return "".concat(prefix, "_").concat(byteSize);
        case "bond":
            return t.rewardDestination
                ? "".concat(prefix, "_").concat(byteSize, "_").concat(t.rewardDestination)
                : "".concat(prefix, "_").concat(byteSize);
        case "unbond":
        case "rebond":
            return "".concat(prefix, "_").concat(byteSize);
        case "nominate":
            return "".concat(prefix, "_").concat((_c = (_b = t.validators) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : "0");
        case "withdrawUnbonded":
            return "".concat(prefix, "_").concat((_d = t.numSlashingSpans) !== null && _d !== void 0 ? _d : "0");
        case "chill":
            return "".concat(prefix);
        case "setController":
            return "".concat(prefix);
        case "claimReward":
            return "".concat(prefix, "_").concat(t.era || "0");
        default:
            throw new Error("Unknown mode in transaction");
    }
};
/**
 * Cache the getTransactionInfo for fees estimation to avoid multiple calls during 5 minutes.
 * Should be force refresh when signing operation.
 *
 * @param {Account} account
 *
 * @returns {Promise<Object>} txInfo
 */
exports.getTransactionParams = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, api_1.getTransactionParams)()];
}); }); }, function () { return "polkadot"; }, {
    maxAge: 5 * 60 * 1000
});
/**
 * Cache the payment info (fee estimate), with a hash depending on fees-changing transaction params and tx size.
 *
 * @param {Account} arg1.a
 * @param {Transaction} arg1.t
 *
 * @returns {Promise<BigBumber>}
 */
exports.getPaymentInfo = (0, cache_1.makeLRUCache)(function (_a) {
    var signedTx = _a.signedTx;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, api_1.paymentInfo)(signedTx)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}, function (_a) {
    var a = _a.a, t = _a.t, signedTx = _a.signedTx;
    return hashTransactionParams(a, t, signedTx);
}, {
    maxAge: 5 * 60 * 1000
});
exports.getRegistry = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, api_1.getRegistry)()];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); }, function () { return "polkadot"; }, {
    maxAge: 60 * 60 * 1000
});
/**
 * Cache the isNewAccount to avoid multiple calls get checking tx status.
 *
 * @param {string} address
 *
 * @returns {Promise<boolean>}
 */
exports.isNewAccount = (0, cache_1.makeLRUCache)(function (address) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, api_1.isNewAccount)(address)];
    });
}); }, function (address) { return address; }, {
    maxAge: 60 * 1000
});
/**
 * Cache the isControllerAddress to avoid multiple calls get checking tx status.
 *
 * @param {string} address
 *
 * @returns {Promise<boolean>}
 */
exports.isControllerAddress = (0, cache_1.makeLRUCache)(function (address) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, api_1.isControllerAddress)(address)];
    });
}); }, function (address) { return address; }, {
    maxAge: 5 * 60 * 1000
});
/**
 * Cache the isElectionClosed to avoid multiple calls get checking tx status.
 * Should be unused if currency is preloaded.
 *
 * @returns {Promise<boolean>}
 */
exports.isElectionClosed = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, api_1.isElectionClosed)()];
    });
}); }, function () { return ""; }, {
    maxAge: 60 * 1000
});
/**
 * Cache the getMinimumBondBalance to avoid too many calls
 *
 * @async
 *
 * @returns {Promise<BigNumber>} consts
 */
exports.getMinimumBondBalance = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, api_1.getMinimumBondBalance)()];
}); }); }, function () { return "polkadot"; }, {
    max: 1,
    maxAge: 60 * 60 * 1000
});
//# sourceMappingURL=cache.js.map